import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function ProductDesc({ }) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { id, categoryId } = useParams();

    useEffect(() => {
        setPageTitle('توضیحات');

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/product/get?id=${id}&=${categoryId}`), { signal });
                const json = await response.json();
                setData(json.data);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='p-4 bc-w br-4 m-4' dangerouslySetInnerHTML={{ __html: data.desc }} />
    );
}